import {
    createCertificateModalInterface,
    setError,
    setFormValues,
    setIsCreateEmployeeModalOpen,
    setIsPostCreateEmployeeSuccess,
} from "../CreateEmployeeModalSlice";
import { Dispatch } from "redux";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { toast } from "react-toastify";

interface HandleCreateEmployeeInterface {
    dispatch: Dispatch;
    postCreateEmployee: (params: { data: Record<string, unknown> }) => {
        unwrap: () => Promise<unknown>;
    };
    formValues?: createCertificateModalInterface["formValues"];
}

export const handleCreateEmployee = async (
    props: HandleCreateEmployeeInterface,
): Promise<string> => {
    const { formValues, postCreateEmployee, dispatch } = props;

    try {
        await postCreateEmployee({
            data: {
                first_name: formValues?.firstName,
                insertion: formValues?.insertion,
                last_name: formValues?.lastName,
                function_group_ids: formValues?.functionGroups?.map(
                    (functionGroup) => functionGroup.selectedId,
                ),
                date_of_birth: formValues?.dateOfBirth,
                place_of_birth: formValues?.placeOfBirth,
                establishment_id: formValues?.establishment?.selectedId,
                ...(formValues?.businessEmail
                    ? { business_email: formValues?.businessEmail }
                    : {}),
                private_email: formValues?.privateEmail,
                mobile_number: formValues?.telephone,
            },
        }).unwrap();

        dispatch(setIsCreateEmployeeModalOpen(false));
        dispatch(setError(null));
        dispatch(setIsPostCreateEmployeeSuccess(true));
        dispatch(
            setFormValues({
                name: null,
                functionGroup: { selectedId: null, selectedValue: null },
                establishment: formValues?.establishment,
                privateEmail: null,
                businessEmail: null,
                telephone: null,
            }),
        );

        toast.success("Medewerker is toegevoegd");
        return "success";
    } catch (error) {
        const errorData = error as ErrorInterface;
        dispatch(setError(errorData.data.message));
        return "failed";
    }
};
